import { CUSTOMER_SERVICE_URL } from '@/app-constants/env.constant';
import { fetchJsonWithAuthorizationAndPersonation } from '@/utils/fetch.utils';
import { getSessionId } from '@/storages/browser.storage';

export enum TrackingEventType {
  PAGE_VIEW = 'page_view',
  CHAT_OPENED = 'chat_opened',
  CHAT_MESSAGE_SENT = 'chat_message_sent',
  LINK_CLICKED = 'link_clicked',
}

interface TrackEventPayload {
  event_type: TrackingEventType;
  module_id: string | null;
  page_path: string;
  component_name?: string;
  referrer_path?: string;
  metadata?: Record<string, unknown>;
}

export const trackEvent = async (payload: TrackEventPayload): Promise<void> => {
  try {
    await fetchJsonWithAuthorizationAndPersonation(`${CUSTOMER_SERVICE_URL}/api/events`, {
      method: 'POST',
      body: JSON.stringify({
        ...payload,
        session_id: getSessionId(),
        user_agent: navigator.userAgent,
        occurred_at: new Date().toISOString(),
      }),
    });
  } catch {
    // Silent fail - tracking must never break user experience
  }
};
